import { atom } from 'jotai';
import localforage from 'localforage';
import { localForageEffect } from './effects/localForageEffect';
import { setDriverIdsToSocketServerEffect } from './effects/setDriverIdsToSocketServerEffect';

export interface DriverOptionDTO {
  value: number; // driver id
  item: string; // driver name
  label: string;
  deleted: boolean;
}

const initDriverIds = async () => {
  const saved = await localforage.getItem<number[]>('driverIds');
  return saved || [];
};

export const driverIdsAtom = atom<number[] | Promise<number[]>>(initDriverIds());

// Effects: persist to IndexedDB and send to socket server
export const driverIdsLocalForageEffectAtom = localForageEffect(driverIdsAtom, 'driverIds');
export const driverIdsSocketEffectAtom = setDriverIdsToSocketServerEffect(driverIdsAtom);
